import '../../polyfills/closest.js'; // IE 11
export default class InteractiveGraphic {
	private elemBody: HTMLElement = document.querySelector('body');
	private elemWrapper: HTMLElement = document.querySelector('.interactiveGraphic__items');
	private elemTriggers: NodeList = document.querySelectorAll('.interactiveGraphic__item');
	private classNameOpen: string = 'hasFocus';
	private arrayTriggers: any = Array.prototype.slice.call(this.elemTriggers);


	constructor() {
		if (!this.elemWrapper) {
			return;
		}
		this.setupEvents();
	}
	closeAll() {
		Array.prototype.forEach.call(this.elemTriggers, (item: HTMLElement) => {
			item.classList.remove(this.classNameOpen);
		});
		// this.elemWrapper.focus(); // Not sure what point of this was, but it was causing big IE 11 issue in which clicking on any link would scroll you to map
	}
	toggleOne(element: HTMLElement) {
		const localArray = Array.prototype.filter.call(this.arrayTriggers, function (value: HTMLElement) {
			return value !== element;
		});
		localArray.forEach((element: HTMLElement) => {
			element.classList.remove(this.classNameOpen);
		});
		element.classList.toggle(this.classNameOpen);
	}
	handleEvent(event: Event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		const element = event.target as HTMLElement;

		if (element){
			if (element.closest('button') && element.closest('button').classList.contains('interactiveGraphic__item')) {
				this.toggleOne(element.closest('button'));
			} else {
				this.closeAll();
			}
		}
	}
	setupEvents() {
		this.elemBody.addEventListener("mousedown", () => {
			this.closeAll();
		}, false);
		this.elemWrapper.addEventListener("mousedown", (event) => {
			this.handleEvent(event);
		}, false);
		this.elemWrapper.addEventListener("focus", (event) => {
			this.handleEvent(event);
		}, true);
	}
}